import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const getToken = () => localStorage.getItem('token');

const api = {
    // Auth
    login: (credentials) => axios.post(`${API_URL}/auth/login`, credentials),
    register: (userData) => axios.post(`${API_URL}/auth/register`, userData),
    
    // Clients
    getClients: () => axios.get(`${API_URL}/clients`, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    createClient: (data) => axios.post(`${API_URL}/clients`, data, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    updateClient: (id, data) => axios.put(`${API_URL}/clients/${id}`, data, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    deleteClient: (id) => axios.delete(`${API_URL}/clients/${id}`, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    
    // Services
    getServices: () => axios.get(`${API_URL}/services`, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    createService: (data) => axios.post(`${API_URL}/services`, data, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    updateService: (id, data) => axios.put(`${API_URL}/services/${id}`, data, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    deleteService: (id) => axios.delete(`${API_URL}/services/${id}`, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    
    // Payments
    getPayments: () => axios.get(`${API_URL}/payments`, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    createPayment: (data) => axios.post(`${API_URL}/payments`, data, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    updatePayment: (id, data) => axios.put(`${API_URL}/payments/${id}`, data, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    deletePayment: (id) => axios.delete(`${API_URL}/payments/${id}`, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    
    // Tasks
    getTasks: () => axios.get(`${API_URL}/tasks`, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    createTask: (data) => axios.post(`${API_URL}/tasks`, data, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    
    // Users
    getUsers: () => axios.get(`${API_URL}/auth/users`, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    updateUser: (id, data) => axios.put(`${API_URL}/auth/users/${id}`, data, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    
    // Dashboard
    getDashboardStats: () => axios.get(`${API_URL}/payments/stats`, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    
    // Generic methods for TasksPage
    get: (url) => axios.get(`${API_URL}${url}`, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    
    post: (url, data) => axios.post(`${API_URL}${url}`, data, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    
    put: (url, data) => axios.put(`${API_URL}${url}`, data, {
        headers: { Authorization: `Bearer ${getToken()}` }
    }),
    
    delete: (url) => axios.delete(`${API_URL}${url}`, {
        headers: { Authorization: `Bearer ${getToken()}` }
    })
};

export default api;